import { Checkbox } from '@m/alchemy-ui/Checkbox';
import { Field } from '@m/alchemy-ui/Field';
import { Input } from '@m/alchemy-ui/Input';
import { useFormikContext } from 'formik';
import { defineMessages, useIntl } from 'react-intl';
import { TranslatableInput } from '../../challenge-management/components';
import { CheckboxColumn, ContentRow, TitleColumn } from '../CustomPage.styled';
import { PAGE_NAVTITLE_TRANSLATE_ID, PAGE_OBJECT_TYPE } from '../common/const';

export const customPageTitleMessages = defineMessages({
  pageTitleLabel: {
    id: 'customPagePageTitleLabel',
    defaultMessage: 'Page Title'
  },
  titlePlaceholder: {
    id: 'customPageTitlePlaceholder',
    defaultMessage: "e.g. 'Home', 'F.A.Q.'"
  },
  requiredTitleError: {
    id: 'customPageRequiredTitleError',
    defaultMessage: 'Provide a title in the default language to show this page in the navigation menu.'
  },
  showInNavigationLabel: {
    id: 'customPageShowInNavigationLabel',
    defaultMessage: 'Show in navigation'
  }
});

const TITLE_INPUT_ID = 'pageNavTitle';

interface CustomPageTitleValues {
  pageNavTitle: string;
  isExclude: boolean;
}

export const CustomPageTitleRow = () => {
  const intl = useIntl();
  const { values, errors, submitCount, handleBlur, handleChange, setFieldValue } =
    useFormikContext<CustomPageTitleValues>();

  const titleLabel = intl.formatMessage(customPageTitleMessages.pageTitleLabel);
  const titleError = submitCount > 0 && errors.pageNavTitle;

  return (
    <ContentRow>
      <TitleColumn>
        <Field
          label={titleLabel}
          required
          isFullWidth
          status={titleError ? { level: 'error', message: errors.pageNavTitle } : undefined}
          input={
            <TranslatableInput
              type={PAGE_OBJECT_TYPE}
              field={PAGE_NAVTITLE_TRANSLATE_ID}
              translateId={PAGE_NAVTITLE_TRANSLATE_ID}
              fieldLabel={titleLabel}
              id={TITLE_INPUT_ID}
            >
              <Input
                id={TITLE_INPUT_ID}
                name="pageNavTitle"
                value={values.pageNavTitle}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder={intl.formatMessage(customPageTitleMessages.titlePlaceholder)}
                aria-required="true"
                aria-invalid={titleError ? true : undefined}
                aria-describedby={titleError ? `${TITLE_INPUT_ID}-status` : undefined}
                hasStatus={Boolean(titleError)}
                palette={titleError ? 'expressiveNegative' : undefined}
                data-testid="custom-page-title-input"
              />
            </TranslatableInput>
          }
        />
      </TitleColumn>

      <CheckboxColumn>
        <Checkbox
          label={intl.formatMessage(customPageTitleMessages.showInNavigationLabel)}
          checked={!values.isExclude}
          onChange={(event) => setFieldValue('isExclude', !event.target.checked)}
          data-testid="custom-page-show-in-navigation-checkbox"
        />
      </CheckboxColumn>
    </ContentRow>
  );
};
